// extracted by mini-css-extract-plugin
export default {"icon-text":"IconText_icon-text__JePjD","icon-text__desc":"IconText_icon-text__desc__UzU5c"};